import { createSlice } from '@reduxjs/toolkit';
import { signIn, getProviderUrl, signOut } from './authSlice';
import {
    createClient,
    deleteClient,
    getClient,
    updateClient,
    statusProductForClient,
    statusAccountTypeForProduct,
    storeClientPolicies,
    updateClientDrivers,
    updateClientSlackChannels,
    getClientCoachMe,
    importClientCoachMe,
    createCrmUserV1,
    createCrmUserV2,
    updateCrmUserV1,
    updateCrmUserV2,
    deleteCrmUserV1,
    deleteCrmUserV2,
    verifyCrmUser,
    getClientDataStore,
    createClientDataStore,
    storeClientWelcomeReminders,
    deleteClientWelcomeReminder,
    deleteClientLogoByCountryCode,
    deleteClientLogoThumbByCountryCode,
    deleteClientFaviconByCountryCode,
    deleteClientEmailLogoByCountryCode,
    getClientHealthCheck,
    getClientReleaseVersion,
} from './clientsSlice';
import { createProduct, editProduct, deleteProduct } from './productsSlice';
import {
    createEmailDriver,
    deleteEmailDriver,
    updateEmailDriver,
    createSmsDriver,
    deleteSmsDriver,
    updateSmsDriver,
    createSlackDriver,
    deleteSlackDriver,
    updateSlackDriver,
    createPushDriver,
    deletePushDriver,
    updatePushDriver,
    updateTermsOfUse,
    updatePrivacyPolicy,
    createApiKey,
    updateApiKey,
    deleteApiKey,
} from './settingsSlice';
import { createTheme, editTheme, deleteTheme } from './themeSlice';
import { createUser, editUser, deleteUser } from './usersSlice';
import {
    createPackage,
    getPackageById,
    editPackage,
    deletePackage,
} from './insuranceSlice';
import {
    createFaq,
    editFaq,
    deleteFaq,
    createFaqsGroup,
    editFaqsGroup,
    deleteFaqsGroup,
    getFaqById,
} from './faqSlice';

const requestsArray = [
    signIn,
    getProviderUrl,
    signOut,
    createClient,
    deleteClient,
    getClient,
    updateClient,
    statusProductForClient,
    statusAccountTypeForProduct,
    storeClientPolicies,
    deleteClientLogoByCountryCode,
    deleteClientLogoThumbByCountryCode,
    deleteClientFaviconByCountryCode,
    deleteClientEmailLogoByCountryCode,
    updateClientDrivers,
    updateClientSlackChannels,
    getClientCoachMe,
    importClientCoachMe,
    createProduct,
    editProduct,
    deleteProduct,
    createEmailDriver,
    deleteEmailDriver,
    updateEmailDriver,
    createUser,
    editUser,
    deleteUser,
    createSmsDriver,
    deleteSmsDriver,
    updateSmsDriver,
    createSlackDriver,
    deleteSlackDriver,
    updateSlackDriver,
    createPushDriver,
    deletePushDriver,
    updatePushDriver,
    updateTermsOfUse,
    updatePrivacyPolicy,
    createTheme,
    editTheme,
    deleteTheme,
    createApiKey,
    updateApiKey,
    deleteApiKey,
    createCrmUserV1,
    createCrmUserV2,
    updateCrmUserV1,
    updateCrmUserV2,
    deleteCrmUserV1,
    deleteCrmUserV2,
    verifyCrmUser,
    createPackage,
    getPackageById,
    editPackage,
    deletePackage,
    getClientDataStore,
    createClientDataStore,
    storeClientWelcomeReminders,
    deleteClientWelcomeReminder,
    createFaq,
    editFaq,
    deleteFaq,
    createFaqsGroup,
    editFaqsGroup,
    deleteFaqsGroup,
    getFaqById,
    getClientHealthCheck,
    getClientReleaseVersion,
];

const extraReducers = requestsArray.reduce((acc, el) => {
    const newObj = {
        [el.pending]: (state, action) => {
            state.showGlobalLoader = true;
        },
        [el.fulfilled]: (state, action) => {
            state.showGlobalLoader = false;
        },
        [el.rejected]: (state, action) => {
            state.showGlobalLoader = false;
        },
    };
    acc = Object.assign(acc, newObj);
    return acc;
}, {});

const initialState = {
    showGlobalLoader: false,
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {},
    extraReducers: extraReducers,
});

/* Selectors */
export const getShowGlobalLoader = (state) => state.app.showGlobalLoader;

export default appSlice.reducer;
